import { render, staticRenderFns } from "./PreferredDaysDue.vue?vue&type=template&id=72bc3b95&"
import script from "./PreferredDaysDue.vue?vue&type=script&lang=js&"
export * from "./PreferredDaysDue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports